import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DialogWrapperConfig} from './dialog-wrapper-config';
import {DialogWrapperService} from "./dialog-wrapper.service";
import {ModalResult} from "./ModalResult";

@Component({
    selector: 'ngx-dialog-wrapper',
    template: require('./dialog-wrapper.component.html'),
    styles: [require('./dialog-wrapper.component.css')]
})
export class DialogWrapperComponent implements OnInit, OnDestroy {
    @Input() config = new DialogWrapperConfig();
    @Input() hideFooter: boolean = false;
    @Output() btnClick = new EventEmitter<any>();
    @Output() dialogResult = new EventEmitter<ModalResult>();
    @Output() onKeyPress = new EventEmitter<string>();
    loaderId: string = this.generateLoaderId();

    constructor(public ds: DialogWrapperService) {
    }

    ngOnInit() {
        this.ds.addDialogId(this.loaderId);
    }

    ngOnDestroy() {
        this.ds.removeDialogId(this.loaderId);
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (this.ds.isTopDialog(this.loaderId)) {
            this.onKeyPress.emit(event.key);

            if (event.key === 'Escape' || event.key === 'Enter')
                event.preventDefault();
        }
    }

    btnClicked(event) {
        this.btnClick.emit(event);
    }

    generateLoaderId() {
        return `loader-${new Date().getMinutes()}-${new Date().getSeconds()}-${new Date().getMilliseconds()}`;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/dialog-wrapper/dialog-wrapper.component.ts